export default __webpack_public_path__ + "static/media/head-basket.c35b2cd2.svg";